"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzSwitchSelector = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

require("./SzSwitchSelector.scss");

exports.SzSwitchSelector = function (_a) {
  var name = _a.name,
      options = _a.options,
      _onChange = _a.onChange,
      selected = _a.selected,
      _b = _a.height,
      height = _b === void 0 ? 40 : _b;
  return react_1.default.createElement("div", {
    className: "d-flex align-content-center sz-switch-selector-wrapper",
    style: {
      height: height
    }
  }, react_1.default.createElement("div", {
    className: "select-option"
  }, (options === null || options === void 0 ? void 0 : options.length) > 0 && options.map(function (item, idx) {
    return react_1.default.createElement("label", {
      className: classnames_1.default('option-label', {
        'selected-option': selected === item.value
      }, {
        'selected-initial': item.initialCheck
      }),
      key: idx
    }, react_1.default.createElement("input", {
      type: "radio",
      id: name + "-" + idx,
      name: name,
      onChange: function onChange(e) {
        return _onChange(name, e);
      },
      value: item.value,
      checked: item.initialCheck || selected === item.value
    }), item.label);
  })));
};

exports.default = exports.SzSwitchSelector;